"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.info = exports.fatal = exports.error = exports["default"] = exports.debug = void 0;
exports.isGatewayLogAPIPathUrl = isGatewayLogAPIPathUrl;
exports.warn = exports.logqueue = exports.log = void 0;
var _queue = _interopRequireDefault(require("./queue"));
var _coreLog = require("../core-log");
var _coreConfig = _interopRequireDefault(require("../core-config"));
var _logLevels = _interopRequireDefault(require("./log-levels"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// index.js

var logqueue = exports.logqueue = new _queue["default"]();

/**
 * logger function to enqueue log entries
 *
 * @param {*} message The log message
 * @param {*} level The log type
*/
function logger(message, level) {
  var logUrl = _coreConfig["default"].get(_coreConfig["default"].internal).gatewayLogAPIPath;
  var logEntry = {
    url: logUrl,
    message: message.message,
    log_type: level,
    datetime: new Date()
  };
  (0, _coreLog.consoleLog)(logEntry);
  logqueue.enqueue(logEntry);
}
var debug = exports.debug = function debug(message) {
  return logger(message, _logLevels["default"].DEBUG);
};
var log = exports.log = function log(messages) {
  return logger(messages, _logLevels["default"].LOG);
};
var info = exports.info = function info(messages) {
  return logger(messages, _logLevels["default"].INFO);
};
var warn = exports.warn = function warn(messages) {
  return logger(messages, _logLevels["default"].WARN);
};
var error = exports.error = function error(messages) {
  return logger(messages, _logLevels["default"].ERROR);
};
var fatal = exports.fatal = function fatal(messages) {
  return logger(messages, _logLevels["default"].FATAL);
};

/**
 * Function to check whether the url is gatewy Log API or not
 *
 * @param {*} url
 * @return {*|boolean} true url is gatewy Log API
 */
function isGatewayLogAPIPathUrl(url) {
  if (url === _coreConfig["default"].get(_coreConfig["default"].internal).gatewayLogAPIPath) {
    return false;
  }
  return true;
}
var _default = exports["default"] = {
  debug: debug,
  log: log,
  info: info,
  warn: warn,
  error: error,
  fatal: fatal,
  logqueue: logqueue
};
//# sourceMappingURL=index.js.map